export default {
  editor_chatTab_text_messagePlaceholder: 'Type a message...',
  editor_chatTab_text_messagePlaceholderNamed: 'Message {peer}',
  mediaTray_chatTab_notification_stickerMessage:
    'sent a sticker - {stickerName} ',
};
